import React from "react";
import { ShieldCheck, BadgeCheck, Truck, RotateCcw } from "lucide-react";

const ITEMS = [
  {
    icon: ShieldCheck,
    title: "100% Authentic",
    body: "Every bag is verified before it ships — no replicas, ever.",
    testid: "trust-authentic",
  },
  {
    icon: BadgeCheck,
    title: "Money-back guarantee",
    body: "If a bag isn't genuine, we refund the full purchase price. No questions.",
    testid: "trust-guarantee",
  },
  {
    icon: Truck,
    title: "Free shipping over $200",
    body: "Tracked end-to-end. Worldwide delivery on us above $200.",
    testid: "trust-shipping",
  },
  {
    icon: RotateCcw,
    title: "14-day returns",
    body: "Changed your mind? Return within 14 days in original condition.",
    testid: "trust-returns",
  },
];

export default function TrustBar({ variant = "light" }) {
  const dark = variant === "dark";
  return (
    <section
      data-testid="trust-bar"
      className={`border-y ${dark ? "border-white/10 bg-[var(--mn-ink)] text-[var(--mn-bg)]" : "border-[var(--mn-border)] bg-[var(--mn-bg)] text-[var(--mn-ink)]"}`}
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 py-10 md:py-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
        {ITEMS.map((it) => {
          const Icon = it.icon;
          return (
            <div key={it.title} className="flex items-start gap-4" data-testid={it.testid}>
              <div className={`shrink-0 w-11 h-11 flex items-center justify-center border ${dark ? "border-white/30" : "border-[var(--mn-ink)]"}`}>
                <Icon size={18} strokeWidth={1.4} />
              </div>
              <div>
                <p className={`eyebrow ${dark ? "text-white/60" : ""}`}>Guarantee</p>
                <p className="font-display text-xl md:text-2xl mt-1 leading-tight tracking-tight">{it.title}</p>
                <p className={`text-sm mt-2 leading-relaxed ${dark ? "text-white/70" : "text-[var(--mn-ink-2)]"}`}>
                  {it.body}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
